// Sentry initialization should be imported first: https://docs.sentry.io/platforms/javascript/guides/react/#configure
import "@src/sentry-init";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "@src/index.css";
import { store } from "@store/store";
import { RouterProvider } from "react-router-dom";
import { router } from "@router/router";
import { LocalizeLoader } from "@loaders/localize-loader";

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <Provider store={store}>
      <LocalizeLoader>
        <RouterProvider router={router} />
      </LocalizeLoader>
    </Provider>
  </StrictMode>
);
